import Collapse from './collapse';
import CollapseItem from './collapse-item.vue';

/* istanbul ignore next */
Collapse.install = function(Vue) {
  Vue.component(CollapseItem.name, CollapseItem);
  Vue.component(Collapse.name, Collapse);
};

export default Collapse;

